import { useState } from "react";
import SegmentFields from "@/components/salgsmuligheter/leads/SegmentFields";
import { buildSegment, segmentToForm, type SegmentFormState } from "@/lib/lead-segment";
import type { LeadSegment } from "@/lib/db-types";

interface AgentSegmentSectionProps {
  /** Agentens lagrede segment ved åpning; seksjonen eier skjemastaten derfra. */
  initial: LeadSegment | null;
  onChange: (segment: LeadSegment) => void;
  onInvalid: (message: string) => void;
}

/** Segmentfeltene for en agent med eksternt segment (CRM-4.2): samme felt som leadlistene, uten omsetning. */
export default function AgentSegmentSection({ initial, onChange, onInvalid }: AgentSegmentSectionProps) {
  const [form, setForm] = useState<SegmentFormState>(() => segmentToForm(initial));
  const update = (next: SegmentFormState) => {
    setForm(next);
    const built = buildSegment(next);
    if ("error" in built) onInvalid(built.error);
    else onChange(built.segment);
  };
  return (
    <fieldset className="space-y-2 border border-border p-3">
      <legend className="px-1 text-sm font-medium">Segment</legend>
      <p className="text-xs text-muted-foreground">
        Agenten finner selskaper i Enhetsregisteret som passer, leser nettsiden deres og melder treff. Treff blir leads i agentens egen liste, eller et signal når selskapet allerede er kunde.
      </p>
      <SegmentFields value={form} onChange={update} hideRevenue />
    </fieldset>
  );
}
